module.exports = __webpack_public_path__ + "static/media/img-jackpotlogo-egt@3x.c8a45e44.png";